import { validateDateString } from "./dateUtils.js";
import _ from "lodash";

export function coerceValue(attribute, rawValue) {
    switch (attribute.type) {
        case "number":
            return toNumber(rawValue);
        case "string":
        case "entry_relation":
        case "global_relation":
            return rawValue;
        case "boolean":
            return rawValue === true || rawValue === "true";
        case "date":
            validateDateString(rawValue);
            return rawValue;
        case "datetime":
            validateDateString(rawValue);
            return rawValue;
        case "string_array":
            return rawValue.toString().split(",");
        case "number_array":
            return rawValue
                .toString()
                .split(",")
                .map((value) => toNumber(value));
        default:
            throw new Error(`Unsupported attribute type: ${attribute.type}`);
    }
}

export function toNumber(rawValue) {
    if (typeof rawValue === "number") {
        return rawValue;
    } else {
        if (_.isNil(rawValue) || rawValue === "") {
            return null;
        }
        const number = Number(rawValue);
        if (isNaN(number)) {
            throw new Error(`Expected a number but got: ${rawValue}`);
        }
        return number;
    }
}
